export default "__VITE_ASSET__CMMktCyH__"